<template>
	<div class="checkbox" :class="{ 'checkbox--error': error }">
		<div class="checkmark" :class="{ 'checkmark--checked': value }">
			<input
				v-bind="$attrs"
				class="input"
				type="checkbox"
				:checked="value"
				@change="$emit('input', !value)"
			/>
			<span><i class="fal fa-check"></i></span>
		</div>
		<div class="right">
			<label class="label" :for="$attrs.id"><slot /></label>
			<div class="error" v-show="error">{{ error }}</div>
		</div>
	</div>
</template>

<script>
export default {
	inheritAttrs: false,
	props: ["value", "error"]
};
</script>

<style lang="scss" scoped>
.checkbox {
	display: flex;
}

.checkmark {
	position: relative;
	width: 16px;
	height: 16px;
	border-radius: 2px;
	background-color: #fefefe;
	box-shadow: inset 0 0 2px rgba(black, 0.2);
	transition: all 0.2s ease-out;
	border: 1px solid transparent;

	.checkbox--error & {
		border-color: red;
	}

	span {
		color: white;
		opacity: 0;
		transition: opacity 0.2s ease-out;
		pointer-events: none;
		position: absolute;
		top: -2px;
	}

	&--checked {
		background-color: $teal;
		span {
			opacity: 1;
		}
	}
}

.input {
	position: absolute;
	opacity: 0;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	display: block;
}

.right {
	flex: 1;
	margin-left: 16px;
}

.error {
	margin-top: 8px;
}
</style>